<template>
  <v-list>
    <template v-for="(item, index) in items">
      <v-divider v-if="item.divider" :key="index"></v-divider>
      <v-list-item
        v-else-if="
          !item.rodada ||
            (item.rodada &&
              rodada.id &&
              ((item.permitir_pedidos === true &&
                rodada.permitir_pedidos === true) ||
                !item.permitir_pedidos))
        "
        :key="item.text"
        @click="limparNotificacoes(item)"
        :to="item.to"
        :disabled="item.disabled"
        :inactive="item.disabled"
      >
        <v-list-item-action>
          <v-badge
            v-if="
              item.notificacoes || (item.badge && rodada.id && !item.impressoes)
            "
            bordered
            dot
            color="error"
            :content="item.notificacoes || ''"
            :value="item.notificacoes"
            overlap
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>

          <v-badge
            v-else-if="item.impressoes"
            bordered
            color="error"
            :content="impressoes_count"
            :value="impressoes_count"
            overlap
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>

          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtext }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list-item href="/chrome/ChromeStandaloneSetup.exe" v-if="!isChrome">
      <v-list-item-action>
        <v-icon>mdi-google-chrome</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Google Chrome</v-list-item-title>
        <v-list-item-subtitle>Download</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "menu-fornecedor",

  props: {
    notificacoes: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.rodada = this.$store.state.rodada;
    this.impressoes_count = this.$store.state.impressoes_count;
  },
  data() {
    return {
      rodada: {},
      impressoes_count: 0,
      items: [
        {
          text: "Página Inicial",
          icon: "mdi-chart-areaspline",
          to: "/dashboard",
          disabled: false,
          rodada: true,
          impressoes: false,
        },
        { text: "Loja", icon: "mdi-storefront", to: "/", disabled: false },
        {
          text: "Produtos",
          icon: "shopping_cart",
          to: "/produtos",
          disabled: false,
          impressoes: false,
        },
        {
          text: "Pedidos",
          icon: "description",
          to: "/pedidos",
          disabled: false,
          impressoes: false,
        },
        {
          text: "Clientes",
          icon: "group",
          to: "/clientes",
          disabled: false,
          rodada: true,
          // permitir_pedidos: true,
          impressoes: false,
        },
        {
          text: "Notificações",
          notificacoes: 0,
          icon: "notifications",
          to: "/notificacoes",
          disabled: false,
          impressoes: false,
        },
        {
          text: "Financeiro",
          icon: "monetization_on",
          to: "/financeiro",
          disabled: true,
          impressoes: false,
        },
        {
          text: "Rodadas de Negócio",
          icon: "mdi-bullseye",
          to: "/rodadas",
          disabled: false,
          badge: true,
          impressoes: false,
        },
        {
          text: "Mapa dos Stands",
          icon: "mdi-map",
          to: `/mapa-stands/${this.$store.state.rodada.id}`,
          disabled: false,
          badge: false,
          visible: !!this.$store.state.rodada.id,
        },
        // {
        //   text: "Agenda",
        //   subtext: "Rodada de Negócios",
        //   icon: "mdi-rhombus-split",
        //   to: "/agenda",
        //   disabled: false,
        // },
        { divider: true },
        {
          text: "Relatórios",
          icon: "mdi-file-chart",
          to: "/relatorios",
          disabled: false,
          rodada: true,
          impressoes: false,
        },
        {
          text: "Impressões",
          icon: "mdi-printer",
          to: "/impressoes",
          disabled: false,
          badge: true,
          impressoes: true,
        },
        {
          text: "Ajuda",
          icon: "mdi-help-circle",
          to: "/ajuda",
          disabled: false,
          badge: true,
          impressoes: false,
        },
      ],
    };
  },
  computed: {
    isChrome() {
      return (
        navigator.userAgent.match(/edg/i) ||
        navigator.userAgent.match(/chrome|chromium|crios/i)
      );
    },
  },
  methods: {
    limparNotificacoes(item) {
      if (item.text === "Notificações") {
        const notif = this.items.find((item) => item.text === "Notificações");
        notif.notificacoes = 0;
      }
    },
  },
  watch: {
    notificacoes: function(value) {
      const notif = this.items.find((item) => item.text === "Notificações");
      notif.notificacoes = this.notificacoes;
    },
    "$store.state.rodada": function() {
      this.rodada = this.$store.state.rodada;
    },
    "$store.state.impressoes_count": function() {
      this.impressoes_count = this.$store.state.impressoes_count;
    },
  },
};
</script>

<style lang="scss" scoped></style>
